import { useContextSelector } from '@fluentui/react-context-selector';
import { Typography } from '@material-ui/core';
import { navigate } from '@reach/router'
import { Button, Cards, CustomIcon } from 'ams-ui-reactkit';
import React, { useEffect, useRef, useState } from 'react'
import { TitleBlock } from '../../../atoms'
import { getSignatureByIndex } from '../../../common/GlobalUtils';
import { StoreContext } from '../../../context';
import { TemplateProps } from '../../../journeys/journey/Interfaces'
import './PickupAuthorization.scss'
import useCommon from "../common/useCommon"
import useSiganture from "../DigitalSignature/useSiganture";
import { getCustomerId, getDailysheetId } from '../../../utils/Utils';
import DynamicHtml from "../../../molecules/DynamicHtml"
import actionTypeConstants from '../../../utils/actionTypeConstants';
import { AddSignatureBlock } from '../../../organisms';

const PickupAuthorization: React.FC<TemplateProps> = (props: any) => {
    const [disabled, setDisabled] = useState(true);
    const { templateProps } = props;
    const signRef = useRef<SignaturePad>(null);
    const signatures: any = useContextSelector(StoreContext, store => store?.appState?.signatures);
    const [btnLoader, setBtnLader] = useState(false)
    const signByInd = getSignatureByIndex(signatures?.list, 4);
    let signUrl = signatures?.list?.find((s: any) => s.sequence === 1);
    const sign = signUrl?.getUrl || ""
    const AgreeCheck: any = signatures?.pickUpAuth?.agreeCheck;

    const customerInfo: any = useContextSelector(StoreContext, store => store?.appState?.customerInfo);

    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);
    const { updateBolStatus } = useCommon();
    const { uploadSignature } = useSiganture();
    const [enableCheckbox, SetEnableCheckBox] = useState(AgreeCheck || false)

    useEffect(() => {
        const isEmpty: boolean | undefined = signRef.current?.isEmpty();
        console.log("===:", isEmpty)
        setDisabled(isEmpty ? true : false);
    }, [signRef && signRef.current?.isEmpty()])

    const handleSubmit = async () => {
        setBtnLader(true);
        if (signByInd && !signByInd?.getUrl && signByInd?.putUrl)
            await uploadSignature(sign, signByInd)
        setBtnLader(false)
        updateBolStatus(getCustomerId(), getDailysheetId(), "COMPLETED")
        dispatch({
            'type': actionTypeConstants.UPDATE_CUSTOMER_INFO,
            'payload': {
                isCompleted: true
            }
        })
        navigate(templateProps?.nextScreen || '/')
    }

    useEffect(() => {
        (enableCheckbox) ? setDisabled(false) : setDisabled(true);
    }, [enableCheckbox])

    const handleSignClick = () => {
        SetEnableCheckBox(!enableCheckbox)
        dispatch({
            type: actionTypeConstants.PICKUP_AUTH_ACCEPT_SIGN,
            payload: {
                status: !enableCheckbox
            }
        })
    }

    return (
        <div className="baseContainerBlock">
            <div className="pickupAuthorisation">
                <Cards variant="default">
                    <div>
                        {
                            customerInfo?.dataResults?.data?.updateBol?.branchId !== 175 ?  <CustomIcon iconName="truck2" size="50" color="red" /> : null
                            
                        }
                        <Typography variant="h5" className="color-green fw-900">
                            {templateProps.secondaryTitle}
                        </Typography>
                    </div>
                </Cards>
                <Cards variant="default">
                    <div className="card-block-main">
                        {templateProps.title && <TitleBlock title={templateProps.title} />}
                        <Typography variant="subtitle2" variantMapping={{ subtitle2: "div" }} align="center" className="pickContent pt-8 pb-8">
                            <DynamicHtml content={templateProps.subtitle} />
                        </Typography>

                        <Typography variant="subtitle2" variantMapping={{ subtitle2: "div" }} align="center" className="mb-8 color-grey">
                            <DynamicHtml content={templateProps.ternaryTitle} />
                        </Typography>

                        <Typography variant="body2" variantMapping={{ body2: "div" }} align="center" className="pickContent fw-600">
                            <DynamicHtml content={templateProps.ternaryContent} />
                        </Typography>

                        <div className="mt-8">
                            <AddSignatureBlock signature={sign} enable={enableCheckbox} onClick={handleSignClick} />
                        </div>

                    </div>
                </Cards>

                <div className="staticFixedButton">
                    <Button
                        text={templateProps?.button}
                        onClick={handleSubmit}
                        color="primary"
                        variant="contained"
                        size="large"
                        disabled={disabled || btnLoader}
                        loading={btnLoader}
                    />
                </div>
            </div>
        </div>
    )
}

export default PickupAuthorization
